import { DATA_TYPE, DATA_TYPE_MEASUREMENT_UNIT_MAP } from "../constants";
import type { DataType, MeasurementUnitType } from "../types/common.types";

type DataTypeRules = {
	measurementUnits: MeasurementUnitType[];
	usesDepth: boolean;
	aggregationType: "average" | "sum";
};

const DATA_TYPES_WITH_DEPTH: DataType[] = [
	DATA_TYPE.water_oxygen_mg_l,
	DATA_TYPE.water_oxygen_percentage,
	DATA_TYPE.water_oxygen_umol,
	DATA_TYPE.water_salinity,
	DATA_TYPE.water_temperature,
	DATA_TYPE.sensor_depth,
	DATA_TYPE.saturation,
];

const DATA_TYPES_AGGREGATE_SUM: DataType[] = [
	DATA_TYPE.Intensity,
	DATA_TYPE.TotalFeedWeight,
	DATA_TYPE.FeedAmount,
	DATA_TYPE.Target,
	DATA_TYPE.Planned,
	DATA_TYPE.Recommended,
	DATA_TYPE.PelletCount,
	DATA_TYPE.pellet_count,
	DATA_TYPE.PelletFishMinute,
	DATA_TYPE.ManualAmount,
	DATA_TYPE.Dose,
	DATA_TYPE.Mean,
	DATA_TYPE.HandFeedWeight,
	DATA_TYPE.recommendedFeedWeight,
	DATA_TYPE.feedStoreAmount,
	DATA_TYPE.runtime,
];

function buildDataTypeRules(dataType: DataType): DataTypeRules {
	const measurementUnits = (
		DATA_TYPE_MEASUREMENT_UNIT_MAP[dataType] ?? []
	) as readonly MeasurementUnitType[];
	const usesDepth = DATA_TYPES_WITH_DEPTH.includes(dataType);
	const aggregationType = DATA_TYPES_AGGREGATE_SUM.includes(dataType) ? "sum" : "average";
	return {
		measurementUnits: [...measurementUnits],
		usesDepth,
		aggregationType,
	};
}

export const DATA_TYPE_RULES: Record<DataType, DataTypeRules> = Object.fromEntries(
	(Object.keys(DATA_TYPE) as DataType[]).map((key) => [key, buildDataTypeRules(key)]),
) as Record<DataType, DataTypeRules>;
